import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row no-wrap" }
const _hoisted_4 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['cursor-pointer', 'text-grey-8' ]),
        style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;'))
      }, " с:  ", 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;'))
        }, [
          _withDirectives(_createVNode(_component_VueDatePicker, {
            utc: "preserve",
            timezone: "Europe/Moscow",
            locale: _ctx.$i18n.locale,
            style: _normalizeStyle('width: '+_ctx.fieldWidth+'px; min-width: '+_ctx.fieldWidth+'px; max-width: '+_ctx.fieldWidth+'px; padding-left: 6px;'),
            teleport: true,
            "model-value": _ctx.theModel.StartDate,
            "onUpdate:modelValue": _ctx.onStartDateChange,
            "enable-time-picker": _ctx.showTime,
            clearable: false,
            disabled: _ctx.startCheckModel,
            required: true,
            format: _ctx.showTime ? _ctx.formatTime : _ctx.formatDate,
            "text-input": _ctx.textInputOptions
          }, null, 8, ["locale", "style", "model-value", "onUpdate:modelValue", "enable-time-picker", "disabled", "format", "text-input"]), [
            [_vShow, !_ctx.startCheckModel]
          ])
        ], 4),
        _createVNode(_component_mosta_checkbox, {
          class: "q-my-none q-py-none text-grey-8 my-check",
          "onUpdate:modelValue": _ctx.updateStartCheck,
          style: _normalizeStyle(_ctx.shiftTop ? 'margin-left: 6px; margin-top: -6px;' : 'margin-left: 6px;'),
          "model-value": _ctx.startCheckModel,
          label: _ctx.$t('first_receipt_date')
        }, null, 8, ["onUpdate:modelValue", "style", "model-value", "label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(['cursor-pointer', 'text-grey-8' ]),
        style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;'))
      }, " по:  ", 4),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;'))
        }, [
          _withDirectives(_createVNode(_component_VueDatePicker, {
            utc: "preserve",
            timezone: "Europe/Moscow",
            locale: _ctx.$i18n.locale,
            style: _normalizeStyle('width: '+_ctx.fieldWidth+'px; min-width: '+_ctx.fieldWidth+'px; max-width: '+_ctx.fieldWidth+'px; padding-left: 6px;'),
            "model-value": _ctx.theModel.EndDate,
            "onUpdate:modelValue": _ctx.onEndDateChange,
            teleport: true,
            clearable: false,
            disabled: _ctx.endCheckModel,
            format: _ctx.showTime ? _ctx.formatTime : _ctx.formatDate,
            "text-input": _ctx.textInputOptions,
            "enable-time-picker": _ctx.showTime
          }, null, 8, ["locale", "style", "model-value", "onUpdate:modelValue", "disabled", "format", "text-input", "enable-time-picker"]), [
            [_vShow, !_ctx.endCheckModel]
          ])
        ], 4),
        _createVNode(_component_mosta_checkbox, {
          class: "q-my-none q-py-none text-grey-8 my-check",
          "onUpdate:modelValue": _ctx.updateEndCheck,
          style: _normalizeStyle(_ctx.shiftTop ? 'margin-left: 6px; margin-top: -6px;' : 'margin-left: 6px;'),
          "model-value": _ctx.endCheckModel,
          label: _ctx.$t('qty_become_date')
        }, null, 8, ["onUpdate:modelValue", "style", "model-value", "label"])
      ])
    ])
  ]))
}